import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _find from 'lodash/find';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Model
import mScenario from 'models/scenario';
import mDoor from 'models/door';
import { isMotherboard } from 'models/deviceSlave';
// Custom
import { deviceDataShape, doorDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const ActionRelayItem = ({ relayAction, device, doors }) => {
  const { slave, relay, state } = mScenario.parseRelayAction(relayAction, device);

  let nestedDoors;
  if (relay && !!doors) {
    const relayDoors = relay.doors;
    if (_size(relayDoors) > 0) {
      nestedDoors = _map(relayDoors, (doorId) => {
        const door = _find(doors, { id: doorId });
        return ({
          key: _toString(door.id),
          icon: mDoor.usage(door).icon,
          label: <LocalizedMessage id={`door.type.${door.type}`} />,
          value: door.name,
        });
      });
    }
  }

  return (
    <InformationItem
      label={<LocalizedMessage id="title.deviceSlave" values={{ isMotherboard: isMotherboard(slave), desc: slave.name }} />}
      value={<LocalizedMessage id="info.relayAction" values={{ relay: relay ? relay.code : 'unknown', state: _toString(state.value) }} />}
      icon={state.icon}
      iconColor={state.color}
      nestedItems={nestedDoors}
    />
  );
};

ActionRelayItem.propTypes = {
  relayAction: PropTypes.string.isRequired,
  device: deviceDataShape.isRequired,
  doors: PropTypes.arrayOf(doorDataShape),
};

ActionRelayItem.defaultProps = {
  doors: null,
};

const mapStateToProps = (state) => ({
  doors: state.installationDoor.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ActionRelayItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ActionRelayItem.js